<template>
<div>
  <div class="darker p-2 border-radius">
    (Only groups can be merged, not single parts)
  </div>
  <div class="section-darker p-2">
    <label class="vform-label white mb-0">{{ $t('stringSearch') }}</label>
    <string-filter
        :filter-id="filterId"
        type="merge"
    />
  </div>
  <div class="mt-3 section-darker p-2">
    <label class="vform-label white mb-0">{{ $t('metaSearch') }}</label>
    <meta-field-filter-2
        v-if="metaSets"
        ref="metaFieldFilter"
        :filter-id="filterId"
        :meta-sets="metaSets"
        :organization-id="organizationId"
        type="merge"
        @setMode="setActive"
    />
  </div>
</div>
</template>

<script>
import StringFilter from "@/components/sfxFilter/StringFilter.vue";
import MetaFieldFilter2 from "@/components/sfxFilter/MetaFieldFilter2.vue";

export default {
  name: "MergeSection",
  components: {MetaFieldFilter2, StringFilter},
  props: {
    filterId: {type: String, required: true},
    organizationId: {type: String, default: ''},
    projectId: {type: String, default: ''},
    assemblyId: {type: String, default: ''},
    metaSets: {type: Array, default: () => []},
  },
  methods: {
    setActive(mode) {
      this.$emit('setMode', mode);
    }
  }
}
</script>

<style lang="scss" scoped>
.section-darker {
  background-color: rgba(255,255,255,0.2);
  padding: 3px 5px;
  border-radius: 5px;
  margin-top: 1px
}
</style>